<template>
  <div class="geoproceso-form form-section">
    <!-- MODO DE SELECCIÓN -->
    <GeoprocesoSelectorModo v-model="otrasCapas" @input="onModeChange" />

    <!-- SELECCIÓN DE CAPA (Si aplica) -->
    <GeoprocesoSelectorCapa 
      v-model="capaOtrasSeleccionada"
      :otrasCapas="otrasCapas"
      :tipoInfluencia="'Lineal'"
      :distancias="distancias"
      :dissolve="dissolve"
      @selection-complete="onSelectionComplete"
    />

    <!-- HERRAMIENTA DE DIBUJO (Si aplica) -->
    <div v-if="!otrasCapas">
      <label>Dibujar Polilínea</label>
      <button :class="['draw-btn', { 'draw-btn--active': drawActive }]" title="Dibujar línea" @click="drawLine">✎</button>
    </div>

    <!-- Disponible tanto al dibujar como al usar una capa existente -->
    <label>Ingrese N° de radios o áreas de influencia:</label>
    <select v-model.number="radioSeleccionado" @change="refreshLineBuffer">
      <option v-for="r in radios" :key="r" :value="r">{{ r }}</option>
    </select>

    <!-- Inputs dinámicos -->
    <div v-if="radioSeleccionado" class="distancias lineal-distancias">
      <label>Radios de influencia: (m)</label>
      <div class="distancia-inputs">
        <input
          v-for="(dist, index) in distancias"
          :key="index"
          type="number"
          :value="dist"
          :min="minimumDistance(index)"
          :disabled="isDistanceDisabled(index)"
          :class="{ 'distance-input-invalid': distanciaEsInvalida(index) }"
          placeholder="Distancia"
          @input="updateDistancia(index, $event.target.value)"
          @blur="normalizeDistancia(index)"
        />
      </div>
      <p v-if="!radiosValidos" class="distance-validation-message">
        {{ mensajeValidacionRadios }}
      </p>
    </div>

    <GeoprocesoOpcionesGenerales
      :capas.sync="capas"
      :metodo.sync="metodo"
      :capasSeleccionadas.sync="capasSeleccionadas"
      :dissolve.sync="dissolve"
    />
  </div>
</template>

<script>
import GeoprocesoBaseMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoBaseMixin';
import GeoprocesoDistanciaMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoDistanciaMixin';
import GeoprocesoOpcionesGenerales from '@/components/mapTools/geoprocessings/forms/GeoprocesoOpcionesGenerales';
import GeoprocesoSelectorModo from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorModo';
import GeoprocesoSelectorCapa from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorCapa';

export default {
  name: 'InfluenciaLinealForm',
  components: { GeoprocesoOpcionesGenerales, GeoprocesoSelectorModo, GeoprocesoSelectorCapa },
  mixins: [GeoprocesoBaseMixin, GeoprocesoDistanciaMixin],
  data() {
    return {
      capaOtrasSeleccionada: '',
      seleccionInfo: null,
      radioSeleccionado: 1,
      distancias: [1],
      drawActive: false,
    };
  },
  watch: {
    otrasCapas(val) {
      if (val) this.drawActive = false;
    },
  },
  methods: {
    drawLine() {
      this.drawActive = true;
      this.$emit('changeDrawType', { name: 'Línea', code: 'LineString' });
    },
    currentPayload() {
      return {
        ...this.getCommonPayload(),
        radioSeleccionado: this.radioSeleccionado,
        distancias: [...this.distancias],
        radiosValidos: this.radiosValidos,
        mensajeValidacionRadios: this.mensajeValidacionRadios,
        capaOtrasSeleccionada: this.capaOtrasSeleccionada,
        seleccionInfo: this.seleccionInfo,
      };
    },
    onSelectionComplete(data) {
      this.seleccionInfo = data;
      this.emitState();
    },
    refreshLineBuffer() {
      // El watcher del mixin ajusta primero el largo de `distancias`.
      this.$nextTick(() => {
        this.emitValidDistances();
      });
    },
  },
};
</script>

<style src="./_geoproceso-forms.css"></style>
<style scoped>
.draw-btn {
  width: 38px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #333;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  margin-bottom: 8px;
}
.draw-btn:hover { background: #444; }
.draw-btn:active { background: #555; transform: scale(0.97); }
.draw-btn--active,
.draw-btn--active:hover { background: #e8730c; border-color: #e8730c; box-shadow: 0 0 0 2px rgba(232, 115, 12, 0.35); }
.lineal-distancias { margin-top: 12px; }
</style>
